import { useQueryClient } from "@tanstack/react-query";
import useAPI, { useAPIMutation } from "@/services/api/hook";
import { ExtendedUseQueryResult } from "@/services/api/types";
import { FormProductMap } from "@/entities/formProductMap/types";

const PRODUCT_MAP_KEY = "forms/productMap";

export const useFormProductMap = (): ExtendedUseQueryResult<FormProductMap> =>
  useAPI(PRODUCT_MAP_KEY);

// The PUT replaces the whole map.
export const useSaveFormProductMap = () => {
  const queryClient = useQueryClient();
  // Returning the refetch keeps the save pending until the saved map shows.
  return useAPIMutation<{ data: FormProductMap }, FormProductMap>(
    PRODUCT_MAP_KEY,
    { method: "PUT" },
    () => queryClient.invalidateQueries({ queryKey: [PRODUCT_MAP_KEY] })
  );
};
